// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fHeader = require('./components/header')
const fCarousels = require('./components/carousels')
const fAccordionList = require('./components/accordion-list')
// const fTabContent = require('./components/tab-content')
const fGsapController = require('./components/gsap-controller')
const fVideo = require('./components/video');
// const fFooterIframe = require('./components/footer-iframe')
const fSelectBox = require('./components/select-box');
const fVueComponents = require('./components/vue-components');
const fColumnList = require('./components/column-list');
import observeAndExecute from './utils/observe-and-execute';

fVueComponents.init();

async function loadAOS() {
    const AOS = await (await import("aos")).default;
    AOS.init({
        once: true,
        offset: window.innerWidth >= 1024 ? -100 : 200,
        duration: 700,
    })
}

window.addEventListener('resize', () => {
    clearTimeout(window._equalResizeTimer);
    window._equalResizeTimer = setTimeout(fColumnList, 100);
});

window.addEventListener("load", () => {
    fSmoothScroll()
    fHeader()
    fAccordionList()
    fSelectBox()
    // fTabContent()
    fGsapController.init()

    fVideo()
    // fFooterIframe.init()

    observeAndExecute(".swiper", () => {
        fCarousels.init();
    }, true);

    observeAndExecute("[data-lazy-src]", (el) => {
        el.setAttribute("src", el.dataset.lazySrc);
    });

    observeAndExecute("[data-aos]", () => {
        loadAOS();
    }, true)
    
    const coworkers = document.querySelectorAll(".coworkers-item");

    for (const coworker of coworkers) {
        const button = coworker.querySelector(".coworkers-item__button");
        const content = coworker.querySelector(".coworkers-item__content");
        
        button?.addEventListener("click", () => {
            button.classList.toggle("rotate-45");
            content.classList.toggle("invisible");
            content.classList.toggle("opacity-0");
        })
    }

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fColumnList);
        setTimeout(fColumnList, 100);
    } else {
        setTimeout(fColumnList, 100);
    }
})